/* GoldN Pop motion. If this file fails, every section stays as painted. */
(function () {
  var reduce = false;
  try {
    reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {
    reduce = false;
  }

  function ready(fn) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", fn, { once: true });
    } else {
      fn();
    }
  }

    ready(function () {
    var header = document.querySelector("[data-gp-header]");
    if (header) {
      var burger = header.querySelector("[data-gp-burger]");
      var drawer = header.querySelector(".gp-drawer");
      var shell = header.closest("[data-gp-stickyhead]");
      var closeTimer = 0;
      var compact = false;

      function setPanel(panel, open) {
        if (!panel) return;
        panel.classList.toggle("is-open", open);
        panel.setAttribute("aria-hidden", open ? "false" : "true");
        if (open) panel.removeAttribute("inert");
        else panel.setAttribute("inert", "");
      }
      function closeMenus() {
        header.querySelectorAll("[data-gp-menu]").forEach(function (btn) {
          btn.setAttribute("aria-expanded", "false");
        });
        header.querySelectorAll("[data-gp-panel]").forEach(function (panel) {
          setPanel(panel, false);
        });
      }
      function showMenu(btn) {
        window.clearTimeout(closeTimer);
        var name = btn.getAttribute("data-gp-menu");
        var panel = header.querySelector('[data-gp-panel="' + name + '"]');
        header.querySelectorAll("[data-gp-menu]").forEach(function (other) {
          other.setAttribute("aria-expanded", other === btn ? "true" : "false");
        });
        header.querySelectorAll("[data-gp-panel]").forEach(function (other) {
          setPanel(other, other === panel);
        });
      }
      function setDrawer(open) {
        header.classList.toggle("is-open", open);
        if (drawer) {
          drawer.classList.toggle("is-open", open);
          drawer.setAttribute("aria-hidden", open ? "false" : "true");
          if (open) drawer.removeAttribute("inert");
          else drawer.setAttribute("inert", "");
        }
        if (burger) burger.setAttribute("aria-expanded", open ? "true" : "false");
        document.documentElement.classList.toggle("gp-nav-open", open);
        if (open) closeMenus();
      }
      function syncHead() {
        if (!shell) return;
        document.documentElement.style.setProperty("--gp-head", shell.offsetHeight + "px");
      }
      function onScroll() {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        if (!compact && y > 48) compact = true;
        else if (compact && y < 8) compact = false;
        if (shell) shell.classList.toggle("is-compact", compact);
        window.requestAnimationFrame(syncHead);
      }

      if (burger) {
        burger.addEventListener("click", function () {
          setDrawer(!header.classList.contains("is-open"));
        });
      }
      header.querySelectorAll("[data-gp-menu]").forEach(function (btn) {
        btn.addEventListener("click", function (event) {
          if (btn.getAttribute("aria-expanded") === "true") return;
          event.preventDefault();
          showMenu(btn);
        });
        btn.addEventListener("mouseenter", function () {
          if (window.matchMedia("(hover: hover) and (pointer: fine)").matches) showMenu(btn);
        });
        btn.addEventListener("focus", function () { showMenu(btn); });
      });
      header.addEventListener("mouseenter", function () {
        window.clearTimeout(closeTimer);
      });
      header.addEventListener("mouseleave", function () {
        if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
        closeTimer = window.setTimeout(closeMenus, 140);
      });
      header.addEventListener("focusout", function (event) {
        var next = event.relatedTarget;
        if (next && header.contains(next)) return;
        closeMenus();
      });
      document.addEventListener("click", function (event) {
        if (!header.contains(event.target)) closeMenus();
      });
      document.addEventListener("keydown", function (event) {
        if (event.key !== "Escape") return;
        var drawerWasOpen = header.classList.contains("is-open");
        var expanded = header.querySelector('[data-gp-menu][aria-expanded="true"]');
        closeMenus();
        setDrawer(false);
        if (drawerWasOpen && burger) burger.focus();
        else if (expanded) expanded.focus();
      });
      syncHead();
      onScroll();
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", syncHead);
    }

    document.querySelectorAll("[data-gp-stories]").forEach(function (row) {
      var track = row.querySelector("[data-gp-stories-track]");
      if (!track) return;
      function shift(dir) {
        var card = track.querySelector("li");
        var step = card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.7;
        track.scrollBy({ left: dir * step, behavior: reduce ? "auto" : "smooth" });
      }
      var prev = row.querySelector("[data-gp-stories-prev]");
      var next = row.querySelector("[data-gp-stories-next]");
      if (prev) prev.addEventListener("click", function () { shift(-1); });
      if (next) next.addEventListener("click", function () { shift(1); });
      var videos = track.querySelectorAll("video");
      videos.forEach(function (video) {
        var frame = video.closest(".gp-stories__frame");
        function mark(on) {
          if (frame) frame.classList.toggle("is-playing", on);
        }
        video.addEventListener("playing", function () { mark(true); });
        video.addEventListener("pause", function () { mark(false); });
        video.addEventListener("ended", function () { mark(false); });
      });
      var paused = false;
      var pauseBtn = row.querySelector("[data-gp-stories-pause]");
      function playVisible() {
        videos.forEach(function (video) {
          var rect = video.getBoundingClientRect();
          if (rect.width < 1 || rect.right < 0 || rect.left > window.innerWidth) return;
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        });
      }
      if (pauseBtn) {
        pauseBtn.addEventListener("click", function () {
          paused = !paused;
          pauseBtn.setAttribute("aria-pressed", paused ? "true" : "false");
          pauseBtn.textContent = paused ? "Play" : "Pause";
          if (paused) {
            videos.forEach(function (video) { video.pause(); });
          } else if (!reduce) {
            playVisible();
          }
        });
      }
      if (reduce || !("IntersectionObserver" in window)) return;
      var playObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (paused) {
            video.pause();
            return;
          }
          if (entry.isIntersecting && entry.intersectionRatio >= 0.65) {
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
      }, { threshold: [0.65] });
      videos.forEach(function (video) { playObs.observe(video); });
    });

    revealReviews();

    document.querySelectorAll("[data-gp-filter]").forEach(function (grid) {
      var root = grid.closest("[data-gp-filters]") || document;
      var buttons = root.querySelectorAll("[data-gp-goal]");
      function apply(goal) {
        buttons.forEach(function (btn) {
          btn.classList.toggle("is-on", btn.getAttribute("data-gp-goal") === goal);
        });
        var shown = 0;
        grid.querySelectorAll("[data-gp-item]").forEach(function (card) {
          var on = goal === "all" || card.getAttribute("data-gp-item") === goal;
          card.classList.toggle("is-on", on);
          card.classList.toggle("is-off", !on);
          if (on) shown += 1;
        });
        grid.classList.add("is-filtered");
        var count = root.querySelector("[data-gp-n]");
        if (count) {
          count.textContent = shown + (shown === 1 ? " product" : " products");
        }
      }
      buttons.forEach(function (btn) {
        btn.addEventListener("click", function () {
          apply(btn.getAttribute("data-gp-goal"));
        });
      });
      var current = root.querySelector("[data-gp-goal].is-on");
      if (current) apply(current.getAttribute("data-gp-goal"));
    });

    document.querySelectorAll("[data-gp-gallery]").forEach(function (gallery) {
      var slides = gallery.querySelectorAll("[data-gp-slide]");
      var thumbs = gallery.querySelectorAll("[data-gp-thumb]");
      var label = gallery.querySelector("[data-gp-gcount]");
      var current = 0;
      function show(index) {
        if (!slides.length) return;
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) {
          slide.classList.toggle("is-on", i === current);
        });
        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle("is-on", i === current);
        });
        if (label) label.textContent = (current + 1) + " / " + slides.length;
        if (thumbs[current] && thumbs[current].scrollIntoView) {
          thumbs[current].scrollIntoView({ block: "nearest", inline: "nearest" });
        }
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          show(Number(thumb.getAttribute("data-gp-thumb")));
        });
      });
      var prev = gallery.querySelector("[data-gp-gprev]");
      var next = gallery.querySelector("[data-gp-gnext]");
      if (prev) prev.addEventListener("click", function () { show(current - 1); });
      if (next) next.addEventListener("click", function () { show(current + 1); });
      var startX = 0;
      gallery.addEventListener("touchstart", function (event) {
        if (!event.changedTouches) return;
        startX = event.changedTouches[0].clientX;
      }, { passive: true });
      gallery.addEventListener("touchend", function (event) {
        if (!event.changedTouches) return;
        var dx = event.changedTouches[0].clientX - startX;
        if (Math.abs(dx) < 40) return;
        show(current + (dx < 0 ? 1 : -1));
      }, { passive: true });
    });

    document.querySelectorAll("[data-gp-qty]").forEach(function (row) {
      var input = row.querySelector("input[name='updates[]']");
      if (!input) return;
      row.querySelectorAll("button").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var dir = btn.getAttribute("data-gp-qty");
          var value = parseInt(input.value, 10) || 1;
          if (dir === "dec") value = Math.max(0, value - 1);
          if (dir === "inc") value = value + 1;
          input.value = String(value);
          if (row.form) row.form.submit();
        });
      });
    });

    document.querySelectorAll("[data-gp-sticky]").forEach(function (bar) {
      var buy = document.getElementById(bar.getAttribute("data-gp-buy"));
      var submit = document.getElementById(bar.getAttribute("data-gp-submit"));
      if (bar.parentElement !== document.body) document.body.appendChild(bar);
      var button = bar.querySelector("[data-gp-sticky-go]");
      if (button && submit) {
        button.addEventListener("click", function () {
          submit.click();
        });
      }
      if (!buy || !("IntersectionObserver" in window)) return;
      var watcher = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          bar.classList.toggle("is-on", show);
        });
      }, { threshold: 0 });
      watcher.observe(buy);
    });

    document.querySelectorAll("[data-gp-privacy]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var manage = document.querySelector(".shopify-pc__banner__btn-manage, #shopify-pc__banner__btn-manage");
        if (manage) {
          event.preventDefault();
          manage.click();
        }
      });
    });

    var ratingTries = 0;
    var ratingTimer = setInterval(function () {
      ratingTries += 1;
      var source = syncHeaderRating();
      if (source === "widget" || ratingTries > 20) clearInterval(ratingTimer);
    }, 300);

    var primeSlot = document.querySelector("[data-gp-prime]");
    if (primeSlot) {
      var selectors = ["bwp-button", "[id^='bwp']", "[class*='bwp-']", "[class*='buy-with-prime']", "iframe[src*='buywithprime']"];
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        var found = null;
        for (var i = 0; i < selectors.length; i += 1) {
          found = document.querySelector(selectors[i]);
          if (found) break;
        }
        if (found && !primeSlot.contains(found)) {
          primeSlot.appendChild(found);
          clearInterval(timer);
        }
        if (tries > 20) clearInterval(timer);
      }, 300);
    }

    if (reduce || !document.documentElement.classList.contains("gp-animate")) return;

    var nodes = document.querySelectorAll("[data-gp]");
    if (!nodes.length || !("IntersectionObserver" in window)) {
      nodes.forEach(function (node) { node.classList.add("gp-in"); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("gp-in");
        if (entry.target.hasAttribute("data-gp-count")) countUp(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.2, rootMargin: "0px 0px -8% 0px" });

    nodes.forEach(function (node) {
      if (node.getAttribute("data-gp") === "load") {
        node.classList.add("gp-in");
        return;
      }
      observer.observe(node);
    });
  });

  function attrNumber(node, name) {
    if (!node) return NaN;
    var raw = node.getAttribute(name);
    var value = parseFloat(raw || "");
    if (value > 0) return value;
    var inner = node.querySelector("[" + name + "]");
    if (!inner || inner === node) return NaN;
    return parseFloat(inner.getAttribute(name) || "");
  }

  function syncHeaderRating() {
    var slots = document.querySelectorAll("[data-gp-stars]");
    if (!slots.length) return false;
    var widget = document.querySelector("#goldn-reviews .jdgm-rev-widg, #goldn-reviews .jdgm-widget");
    var painted = "";
    slots.forEach(function (slot) {
      var badge = slot.querySelector(".jdgm-prev-badge, .jdgm-preview-badge, [data-average-rating]");
      var source = "";
      var avg = attrNumber(widget, "data-average-rating");
      if (avg > 0) source = "widget";
      if (!(avg > 0) && widget) {
        var summary = widget.querySelector(".jdgm-rev-widg__summary-average");
        if (summary) avg = parseFloat((summary.textContent || "").replace(/[^0-9.]/g, ""));
        if (avg > 0) source = "widget";
      }
      if (!(avg > 0)) {
        avg = attrNumber(badge, "data-average-rating");
        if (avg > 0) source = "badge";
      }
      if (!(avg > 0)) {
        avg = attrNumber(badge, "data-score");
        if (avg > 0) source = "badge";
      }
      if (!(avg > 0)) return;
      var count = attrNumber(widget, "data-number-of-reviews");
      if (!(count > 0)) count = attrNumber(badge, "data-number-of-reviews");
      var shown = (Math.round(avg * 10) / 10).toFixed(1);
      var row = slot.querySelector("[data-gp-rating]");
      var fill = slot.querySelector("[data-gp-rating-fill]");
      var label = slot.querySelector("[data-gp-rating-label]");
      if (!row || !fill || !label) return;
      var pct = Math.max(0, Math.min(100, (parseFloat(shown) / 5) * 100));
      fill.style.width = pct + "%";
      var text = shown;
      if (count > 0) {
        text += " · " + count + (count === 1 ? " review" : " reviews");
      }
      label.textContent = text;
      row.hidden = false;
      slot.classList.add("is-live");
      painted = source;
    });
    return painted;
  }

  function revealReviews() {
    var roots = document.querySelectorAll("#goldn-reviews, #goldn-reviews-home, .gp-reviews");
    roots.forEach(function (root) {
      root.querySelectorAll(".jdgm-temp-hiding-style").forEach(function (style) {
        style.disabled = true;
        style.textContent = "";
      });
      var widget = root.querySelector(".jdgm-review-widget, .jdgm-widget");
      if (!widget) return;
      var legacy = widget.querySelector(".jdgm-legacy-widget-content");
      var live = false;
      Array.prototype.forEach.call(widget.children, function (child) {
        if (child.tagName === "STYLE") return;
        if (legacy && (child === legacy || legacy.contains(child))) return;
        var text = (child.innerText || "").replace(/\s+/g, " ").trim();
        if (text.length > 40 || child.offsetHeight > 120) live = true;
      });
      if (live && legacy) {
        root.classList.add("gp-jdgm-live");
        legacy.style.setProperty("display", "none", "important");
      }
    });
  }

  function countUp(el) {
    if (el.getAttribute("data-gp-counted") === "1") return;
    var raw = (el.textContent || "").trim();
    var match = raw.match(/(\d[\d,]*\.?\d*)/);
    if (!match) return;
    var num = parseFloat(match[1].replace(/,/g, ""));
    if (!isFinite(num)) return;
    el.setAttribute("data-gp-counted", "1");
    var decimals = (match[1].split(".")[1] || "").length;
    var start = performance.now();
    function frame(now) {
      var t = Math.min(1, (now - start) / 900);
      var eased = 1 - Math.pow(1 - t, 3);
      var next = (num * eased).toFixed(decimals);
      el.textContent = raw.replace(match[1], next);
      if (t < 1) requestAnimationFrame(frame);
      else el.textContent = raw;
    }
    requestAnimationFrame(frame);
  }
})();
